export interface IPricingTable {
  id?: number
  uuid?: string
  description: string
  start_date: string
  end_date: string
}

export const pricingTableInitValues: IPricingTable = {
  //id: 0,
  description: '',
  start_date: '',
  end_date: '',
}
